<template>
  <div v-show="position.show" ref="chart" class="chart"></div>
</template>
<script>
import { isEmpty, cloneDeep, debounce } from 'lodash'
import china from '@/components/config/china.json'
// import zheJiang from '@/components/config/zhejiang.json'
import { JDATA_API } from '@/api'
import ExternalLoader from '@/utils/externalLoader'

export default {
  data() {
    return {
      chart: null,
      json: ''
    }
  },
  props: {
    customChartData: {
      type: Array,
      default: () => []
    },
    // 自定义图表
    chartType: {
      type: String,
      default: ''
    },
    // 自定义图表
    customChartJs: {
      type: String,
      default: ''
    },
    iid: {
      type: String,
      default: ''
    },
    option: {
      // 配置参数包括数据
      type: Object,
      default() {
        return {}
      }
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$nextTick(() => {
      this.init(this.option)
    })
  },
  mounted() {
    this.$nextTick(() => {
      ExternalLoader.load(['echarts.min.js']).then(() => {
        if (this.iid && this?.option?.geo?.map && this.option.geo.map === 'china') {
          this.$echarts.registerMap('china', china)
          // window.echart.registerMap('china', china)
        } else if (this.iid && this?.option?.geo?.map && this.option.geo.map !== 'china') {
          this.getMapJson(this.option.geo.map)
        }
        // setTimeout(() => {
        //   this.init(this.option)
        // }, 1000)
        // this.init(this.customChartData)
      })
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
    // 自定义图表 需要清除挂在window 对象上的元素
    this.handleDelCustomChart()
  },
  watch: {
    // 监听参数配置对象的变化 更新图表视图 300ms
    option: {
      handler: debounce(function(newObject) {
        // if (!isEmpty(newObject) && this.chartType !== 'CustomChartConfig') {
        if (!isEmpty(newObject)) {
          this.chart.setOption(newObject, { notMerge: true })
        }
      }, 300),
      deep: true
    },
    // customChartJs: {
    //   handler: debounce(function(newObject) {
    //     if (!isEmpty(newObject) && this.chartType === 'CustomChartConfig') {
    //       this.handleGenerateCustomChart()
    //     }
    //   }, 300),
    //   deep: true
    // },
    customChartData: {
      handler: function(val) {
        if (!isEmpty(val) && this.chartType === 'CustomChartConfig') {
          this.handleGenerateCustomChart()
        }
      },
      deep: true
    }
  },
  methods: {
    init(option) {
      this.chart = this.$echarts.init(this.$refs.chart)
      if (this.chartType === 'CustomChartConfig') {
        this.handleGenerateCustomChart(option)
      } else {
        // 懒加载图表
        this.chart.setOption(option, { notMerge: true })
      }
    },
    async getMapJson(jsonId) {
      try {
        const res = await JDATA_API.getMapJson({ jsonId })
        if (res.success) {
          if (res?.data?.json) {
            // const json = res.data.json
            this.json = JSON.parse(res.data.json)
            // window.echarts.registerMap(jsonId, json)
            window.echart.registerMap(jsonId, this.json)
          } else {
            this.$message.warning({
              content: '当前所选地区未找到地理位置数据，请在后台手动上传json数据',
              duration: 1,
              key: 'map'
            })
          }
        }
      } catch (error) {
        console.log('error: ', error)
      }
    },
    // 处理自定义图表 - 生成
    handleGenerateCustomChart() {
      if (this.customChartJs) {
        // this.$echarts.registerMap('hangzhou', zheJiang)
        const iid = this.iid
        // if (!window[`CUSTOM_DATA_${iid}`]) {
        //   window[`CUSTOM_DATA_${iid}`] = cloneDeep(this.customChartData)
        // }
        window[`CUSTOM_DATA_${iid}`] = cloneDeep(this.customChartData)
        // console.log('customChartData: ', this.customChartData)
        clearInterval(window[`CUSTOM_INTERVAL_${iid}`])
        window[`CUSTOM_INTERVAL_${iid}`] = null
        delete window[`CUSTOM_INTERVAL_${iid}`]
        // console.log('this >', this)
        const config = JSON.parse(this.customChartJs)
        window[iid] = {}
        window[iid]['myChart'] = this.chart
        const replaceStr = `window['${iid}'].myChart`
        const intervalStr = `window['CUSTOM_INTERVAL_${iid}'] = setInterval`
        let fmt = config.replace(/myChart/g, replaceStr)
        fmt = fmt.replace(/setInterval/g, intervalStr)
        // fmt = fmt.replace(/echarts/g, 'this.$echarts')
        fmt = fmt.replace(/echarts/g, 'window.echart')
        // eslint-disable-next-line no-eval
        window.echart.registerMap('china', china)
        eval(fmt)
        this.chart.hideLoading()
      }
    },
    // 处理自定义图表 - 删除
    handleDelCustomChart() {
      if (this.chartType === 'CustomChartConfig') {
        const iid = this.iid
        if (window[`CUSTOM_INTERVAL_${iid}`]) {
          clearInterval(window[`CUSTOM_INTERVAL_${iid}`])
          window[`CUSTOM_INTERVAL_${iid}`] = null
          delete window[`CUSTOM_INTERVAL_${iid}`]
        }
        if (window[iid]) delete window[iid]
        delete window[`CUSTOM_DATA_${iid}`]
      }
    }
  }
}
</script>
<style lang="less" scoped>
.chart {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>
